import React from "react";
import { useLocalization } from "../../../context/LocalizeContextProvider";
import { languages } from "../../../utils/constants";
import DropdownField from "../../components/DropdownField";
import HeaderProfile from "../../components/HeaderProfile";
import { getSupabaseRefreshToken, getSupabaseSession } from "../../../utils/supabaseStorage";
import { supabase } from "../../../utils/supabaseClient";
import { BASE_API_URL } from "../../../config/api";

const Header = ({ onNote, title }) => {
  const { setLocale, defaultLocale, getText } = useLocalization();
  var path = window.location?.pathname.split("/");
  let name = path[1].split("-");
  if (path.includes("dashboard") && path.length > 2) {
    name = path[2];
  }
  var filterName = name;

  return (
    <div className="header border-bottom">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
                id="title-page"
              >
                {!title && !filterName ? "Dashboard" : getText(filterName)}
              </div>
            </div>
<ul className="navbar-nav header-right main-notification d-flex align-items-center gap-3">
              {window.location.hostname.includes('stg.') && (
                <li className="nav-item">
                  <button
                    className="btn btn-xs btn-outline-warning"
                    onClick={async () => {
                      const tokenDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
                      const sdkSession = getSupabaseSession();
                      const refreshToken = getSupabaseRefreshToken() || tokenDetails.refresh_token;
                      console.log("[DEBUG REFRESH] expireDate:", tokenDetails.expireDate);
                      console.log("[DEBUG REFRESH] now:", new Date().toISOString());
                      console.log("[DEBUG REFRESH] refreshToken (first 20):", refreshToken?.substring(0, 20));
                      console.log("[DEBUG REFRESH] supabase SDK session exists:", !!sdkSession);
                      try {
                        const baseUrl = BASE_API_URL || '';
                        const resp = await fetch(`${baseUrl}/token/refresh`, {
                          headers: { refreshToken: refreshToken || '' },
                        });
                        const data = await resp.json();
                        console.log("[DEBUG REFRESH] status:", resp.status);
                        console.log("[DEBUG REFRESH] response:", JSON.stringify(data).substring(0, 200));
                        if (resp.ok && data.id_token) {
                          const expiresIn = parseInt(data.expiresIn, 10) || 3600;
                          const updated = {
                            ...tokenDetails,
                            id_token: data.id_token,
                            refresh_token: data.refresh_token,
                            expiresIn,
                            expireDate: new Date(Date.now() + expiresIn * 1000).toISOString(),
                          };
                          localStorage.setItem("userDetails", JSON.stringify(updated));
                          if (data.id_token && data.refresh_token) {
                            await supabase.auth.setSession({
                              access_token: data.id_token,
                              refresh_token: data.refresh_token,
                            });
                          }
                          console.log("[DEBUG REFRESH] ✅ SUCCESS — new expireDate:", updated.expireDate);
                          alert("Token refreshed! Check console.");
                        } else {
                          console.error("[DEBUG REFRESH] ❌ FAILED:", data);
                          alert("Refresh FAILED: " + JSON.stringify(data));
                        }
                      } catch (err) {
                        console.error("[DEBUG REFRESH] ❌ ERROR:", err);
                        alert("Refresh ERROR: " + err.message);
                      }
                    }}
                  >
                    🔄 Refresh
                  </button>
                </li>
              )}
              <img
                src={languages.find((value) => value.id === defaultLocale).icon}
                width={30}
                alt=""
              />
              <DropdownField
                label={
                  languages.find((value) => value.id === defaultLocale).label
                }
                datas={languages || []}
                onChange={(value) => setLocale(value)}
                variant="transparent"
              />
              <HeaderProfile />

              {/* <li className="nav-item header-profile">
					<Link to={"#"} className="nav-link" role="button" data-bs-toggle="dropdown">
						<img src={profile} width="20" alt=""/>
					</Link>
				</li> */}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
